export default __webpack_public_path__ + "static/media/Contact.9d0adb08.png";